import { acceptanceOfBill2 } from '@/api/index'

export function deleteBill (data) {
  return acceptanceOfBill2.request({
    method: 'post',
    url: '/deleteBill',
    data
  })
}

export function Check_deleteBill (data) {
  return acceptanceOfBill2.request({
    method: 'post',
    url: '/Check_deleteBill',
    data
  })
}

export function dptb_save (data) {
  return acceptanceOfBill2.request({
    method: 'post',
    url: '/dptb_save',
    data
  })
}
